export default "__VITE_ASSET__C9pd5dLv__"